import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_CUPON] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.cupon = payload
  },
  [types.SET_CUPONS] (state, payload) {
    state.cupons = payload.data
    state.pagination = payload.meta.pagination
  }
}
